module.exports = __webpack_public_path__ + "img/chart.9d29a6b3.jpeg";